import { render, staticRenderFns } from "./Organisation.vue?vue&type=template&id=82427ea0&"
import script from "./Organisation.vue?vue&type=script&lang=js&"
export * from "./Organisation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports